import { render, staticRenderFns } from "./bindMerchantStore.vue?vue&type=template&id=6b1d3002&scoped=true"
import script from "./bindMerchantStore.vue?vue&type=script&lang=js"
export * from "./bindMerchantStore.vue?vue&type=script&lang=js"
import style0 from "./bindMerchantStore.vue?vue&type=style&index=0&id=6b1d3002&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1d3002",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b1d3002')) {
      api.createRecord('6b1d3002', component.options)
    } else {
      api.reload('6b1d3002', component.options)
    }
    module.hot.accept("./bindMerchantStore.vue?vue&type=template&id=6b1d3002&scoped=true", function () {
      api.rerender('6b1d3002', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/goodsChannel/bindMerchantStore.vue"
export default component.exports